import { AUTOSHIP_ELIGIBILITY_BANNER_IMPRESSION_KEY } from '@libs/core';

const IMPRESSION_VALUE = '1';

const sameTabImpressionClears = new WeakSet<StorageEvent>();

export function isSameTabAutoshipEligibilityBannerClear(event: StorageEvent): boolean {
    return sameTabImpressionClears.has(event);
}

export function hasAutoshipEligibilityBannerImpression(): boolean {
    try {
        return globalThis.localStorage.getItem(AUTOSHIP_ELIGIBILITY_BANNER_IMPRESSION_KEY) != null;
    } catch {
        return false;
    }
}

export function recordAutoshipEligibilityBannerImpression(): void {
    try {
        globalThis.localStorage.setItem(AUTOSHIP_ELIGIBILITY_BANNER_IMPRESSION_KEY, IMPRESSION_VALUE);
    } catch {
        // Private mode and disabled cookies mode must not break the cart.
    }
}

export function clearAutoshipEligibilityBannerImpression(): void {
    try {
        globalThis.localStorage.removeItem(AUTOSHIP_ELIGIBILITY_BANNER_IMPRESSION_KEY);
        const event = new StorageEvent('storage', {
            key: AUTOSHIP_ELIGIBILITY_BANNER_IMPRESSION_KEY,
            newValue: null,
            storageArea: globalThis.localStorage,
            url: globalThis.location.href,
        });
        sameTabImpressionClears.add(event);
        globalThis.dispatchEvent(event);
    } catch {
        // Login must still complete when storage is unavailable.
    }
}
